<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.title = "康吉森工业互联网平台"
  }
}
</script>

<style>
#app {
  height:100%;
  background: #FFF;
}
</style>
